/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v2beta1/pipeline.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { V2beta1PipelineVersion } from './V2beta1PipelineVersion';
import {
  V2beta1PipelineVersionFromJSON,
  V2beta1PipelineVersionFromJSONTyped,
  V2beta1PipelineVersionToJSON,
  V2beta1PipelineVersionToJSONTyped,
} from './V2beta1PipelineVersion';

/**
 *
 * @export
 * @interface V2beta1ListPipelineVersionsResponse
 */
export interface V2beta1ListPipelineVersionsResponse {
  /**
   * Returned pipeline versions.
   * @type {Array<V2beta1PipelineVersion>}
   * @memberof V2beta1ListPipelineVersionsResponse
   */
  pipeline_versions?: Array<V2beta1PipelineVersion>;
  /**
   * The token to list the next page of pipeline versions.
   * @type {string}
   * @memberof V2beta1ListPipelineVersionsResponse
   */
  next_page_token?: string;
  /**
   * The total number of pipeline versions for the given query.
   * @type {number}
   * @memberof V2beta1ListPipelineVersionsResponse
   */
  total_size?: number;
}

/**
 * Check if a given object implements the V2beta1ListPipelineVersionsResponse interface.
 */
export function instanceOfV2beta1ListPipelineVersionsResponse(
  value: object,
): value is V2beta1ListPipelineVersionsResponse {
  return true;
}

export function V2beta1ListPipelineVersionsResponseFromJSON(
  json: any,
): V2beta1ListPipelineVersionsResponse {
  return V2beta1ListPipelineVersionsResponseFromJSONTyped(json, false);
}

export function V2beta1ListPipelineVersionsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V2beta1ListPipelineVersionsResponse {
  if (json == null) {
    return json;
  }
  return {
    pipeline_versions:
      json['pipeline_versions'] == null
        ? undefined
        : (json['pipeline_versions'] as Array<any>).map(V2beta1PipelineVersionFromJSON),
    next_page_token: json['next_page_token'] == null ? undefined : json['next_page_token'],
    total_size: json['total_size'] == null ? undefined : json['total_size'],
  };
}

export function V2beta1ListPipelineVersionsResponseToJSON(
  json: any,
): V2beta1ListPipelineVersionsResponse {
  return V2beta1ListPipelineVersionsResponseToJSONTyped(json, false);
}

export function V2beta1ListPipelineVersionsResponseToJSONTyped(
  value?: V2beta1ListPipelineVersionsResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    pipeline_versions:
      value['pipeline_versions'] == null
        ? undefined
        : (value['pipeline_versions'] as Array<any>).map(V2beta1PipelineVersionToJSON),
    next_page_token: value['next_page_token'],
    total_size: value['total_size'],
  };
}
